const initialState = {
  active: true,
  provider: {
    brandName: '',
    code: '',
    key: '',
    network: '',
    relatedTariff: null,
    unportable: false
  },
  portingData: {
    msisdn: '',
    dateType: '',
    confirmation: false
  },
  contractHolder: {
    active: false,
    firstName: '',
    lastName: '',
    birthDate: '',
    confirmation: false
  },
  providerList: [],
  providerListLoadingStatus: ''
}

const MnpDataModule = {
  namespaced: true,
  state: initialState,
  getters: {
    active: (state) => {
      return state.active
    },
    provider: (state) => {
      return state.provider
    },
    portingData: (state) => {
      return state.portingData
    },
    contractHolder: (state) => {
      return state.contractHolder
    },
    providerList: (state) => {
      return state.providerList
    },
    providerListLoadingStatus: (state) => {
      return state.providerListLoadingStatus
    }
  },
  actions: {
    async getProviderList ({ state, commit, rootGetters }) {
      // initialize
      commit('clearMessages', {}, { root: true })
      // check for prefetched data
      if (state.providerListLoadingStatus !== 'LOADED') {
        if (typeof window.$gqlpre.mnpProvidersWithTariffs !== 'undefined') {
          state.providerList = Object.values(window.$gqlpre.mnpProvidersWithTariffs)
          state.providerListLoadingStatus = 'LOADED'
        } else {
          state.providerListLoadingStatus = 'ERROR'
        }
      }
    }
  },
  mutations: {
    setActive (state, active) {
      state.active = active
    },
    setProvider (state, provider) {
      state.provider = {
        brandName: provider?.brandName || '',
        network: provider?.network || '',
        key: provider?.key || '',
        code: provider?.code || '',
        relatedTariff: provider?.relatedTariff || null,
        unportable: provider?.unportable || false
      }
    },
    setPortingData (state, portingData) {
      state.portingData = {
        msisdn: portingData?.msisdn.replace(/([^0-9+])/g, '').trim() || '',
        dateType: portingData?.dateType || '',
        confirmation: portingData?.confirmation || false
      }
    },
    setContractHolder: (state, contractHolder) => {
      state.contractHolder = contractHolder
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  }
}

export default MnpDataModule
